button-link-group {
    display: flex;
    align-items: center;
    flex-direction: column;

    button-link {
        text-align: center;
        width: 100%;
    }

    button-link:nth-child(n+2) {
        margin-top: 40px;
    }
}